import React, { useState } from "react";
import {
  Layout,
  Menu,
  Drawer,
  Button,
  Grid,
  Dropdown,
  Typography,
  Space,
} from "antd";
import {
  MenuOutlined,
  DashboardOutlined,
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  DownOutlined,
  FileImageOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { useAuth } from "../contexts/AuthContext";
import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";

const { Header, Sider, Content } = Layout;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const DashboardLayout = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  
  const navigate = useNavigate();
  const location = useLocation();
  const { user,logout } = useAuth();

  const handleLogout = () => {
    logout()
    navigate("/login");
  };

  const adminMenu = [
    {
      key: "/admin/dashboard",
      icon: <DashboardOutlined />,
      label: <Link to="/admin/dashboard">Dashboard</Link>,
    },
    {
      key: "/admin/users",
      icon: <UserOutlined />,
      label: <Link to="/admin/users">Manage Users</Link>,
    },
    {
      key: "/admin/reports",
      icon: <BarChartOutlined />,
      label: <Link to="/admin/reports">Reports</Link>,
    },
    {
      key: "/user/settings",
      icon: <SettingOutlined />,
      label: <Link to="/admin/settings">Settings</Link>,
    },
  ];

  // USER MENU
  const userMenu = [
    {
      key: "/user/dashboard",
      icon: <DashboardOutlined />,
      label: <Link to="/user/dashboard">Dashboard</Link>,
    },
    {
      key: "/user/analyzer",
      icon: <FileImageOutlined />,
      label: <Link to="/user/analyzer">Eye Analyzer</Link>,

    },
    {
      key: "/user/profile",
      icon: <UserOutlined />,
      label: <Link to="/user/profile">Reports</Link>,
    }
  ];
  const menuItems = user?.role === "admin" ? adminMenu : userMenu;

  // ---- USER DROPDOWN ----
  const userMenuItems = [
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
    },
  ];

  const onUserMenuClick = ({ key }) => {
    if (key === "logout") handleLogout();
  };

  // ---- DATE ----
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <Layout className="min-h-screen bg-[#f9fbfc]">
      {/* SIDEBAR (Desktop) */}
      {!isMobile && (
        <Sider
          width={240}
          className="!bg-white !border-r !border-gray-100 !shadow-sm flex flex-col justify-between fixed left-0 top-0 h-screen z-20"
        >
          <div>
            {/* LOGO */}
            <div className="flex items-center justify-center h-20 border-b border-gray-100">
              <img
                src="/assets/logo.png"
                alt="Logo"
                className="w-[150px] h-[45px] object-contain"
              />
            </div>

            {/* MENU */}
            <Menu
              mode="inline"
              // defaultSelectedKeys={["/user/dashboard"]}
              selectedKeys={[location.pathname]}
              items={menuItems}
              style={{
                background: "transparent",
                borderRight: "none",
                fontWeight: 500,
                paddingTop: 10,
              }}
            /> 
          </div>
        </Sider>
      )}

      {/* MAIN CONTENT */}
      <Layout
        className={`transition-all duration-300 ${
          !isMobile ? "ml-[240px]" : ""
        }`}
      >
        {/* HEADER */}
        <Header className="bg-white flex justify-between items-center px-5 border-b border-gray-100 h-[72px] shadow-sm sticky top-0 z-10">
          <div className="flex items-center gap-3">
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setDrawerVisible(true)}
              />
            )}
            <div className="flex flex-col leading-tight">
              <Title
                level={5}
                className="!m-0 !p-0 !font-semibold !text-[#1c5a85]"
              >
                Dashboard
              </Title>
              <Text type="secondary" className="text-xs">
                {today}
              </Text>
            </div>
          </div>

          {/* USER DROPDOWN */}
          <Dropdown
            menu={{ items: userMenuItems, onClick: onUserMenuClick }}
            placement="bottomRight"
            arrow
          >
            <Button
              type="text"
              size="small"
              className="flex items-center gap-2 text-[#1c5a85] font-medium hover:bg-[#f2f7fb] rounded-lg px-3"
            >
              <Space size={4}>
                {user?.fullName || "User"}
                <DownOutlined style={{ fontSize: 10 }} />
              </Space>
            </Button>
          </Dropdown>
        </Header>

        {/* MOBILE DRAWER */}
        <Drawer
          title="Menu"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
        >
          <Menu
            mode="inline"
            defaultSelectedKeys={["dashboard"]}
            items={menuItems}
          />
        </Drawer>

        {/* PAGE CONTENT */}
        <Content className="m-5 p-6 bg-white rounded-2xl shadow-[0_3px_12px_rgba(0,0,0,0.05)] min-h-[75vh] transition-all duration-300">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default DashboardLayout;
